import axios from 'axios';
import { protectedResourcesScopes } from '../../../../../auth/config';
import { acquireToken } from '../../../../../auth/msal.js';

// const apiUrl = process.env.REACT_APP_V2_API_URL
const apiUrl = `https://meris-backend.ashyflower-93837a9b.brazilsouth.azurecontainerapps.io`;
const scope = protectedResourcesScopes.core;



export async function getTests(instance) {
    try {
        const accessToken = await acquireToken(instance, scope);
        const { data } = await axios.get(`${apiUrl}/commissioning-test`, {
            headers: { Authorization: `Bearer ${accessToken}` },
        });
        return data
        //     {
        //         "title": "Teste de Resistência de Isolamento - Cabos BT",
        //         "reportName": "Relatório de Teste de Resistência de Isolamento - Cabos BT",
        //         "code": "RTCB",
        //         "platform": "mobile",
        //         "allowedAttempts": 3,
        //         "assetCategories": [
        //             "mechanical",
        //             "electrical"
        //         ],
        //         "id": "687feefc31f8dd31a973abb0"
        //     }
        // ];
    } catch (e) {
        throw e;
    }
}

export async function getTestById(instance, id) {
    try {
        const accessToken = await acquireToken(instance, scope);
        const { data } = await axios.get(`${apiUrl}/commissioning-test/${id}`, {
            headers: { Authorization: `Bearer ${accessToken}` },
        });

        return data
    } catch (e) {
        throw e;
    }
}

export async function createTest(instance, test) {
    try {
        const accessToken = await acquireToken(instance, scope);
        const { data } = await axios.post(`${apiUrl}/commissioning-test`, test, {
            headers: { Authorization: `Bearer ${accessToken}` },
        });
        return data;
    } catch (e) {
        throw e;
    }
}

export async function updateTest(instance, id, test) {
    try {
        const accessToken = await acquireToken(instance, scope);
        const { data } = await axios.put(`${apiUrl}/commissioning/test/${id}`, test, {
            headers: { Authorization: `Bearer ${accessToken}` },
        });
        return data;
    } catch (e) {
        throw e;
    }
}